import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {useConfirmBooking} from 'presentation/pages/private/booking/hooks';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {translations} from 'presentation/translations-new';
import {checkConfirmAppointment} from 'presentation/utils';

const {confirmAppointmentModal} = translations['pt-br'].privateFlow.myAppointments;

export function useConfirmToGoButton(appointment: AppointmentsHomeStateType) {
	const {bookingNumber, bookingType} = appointment;
	const isSurgery = bookingType === BookingTypeEnum.SURGERY;
	const isExam = bookingType === BookingTypeEnum.EXAM;
	const isOdonto = bookingType === BookingTypeEnum.ODONTO;

	const {
		confirmExam,
		confirmHealth,
		confirmOdonto,
		isPending,
		isError,
		isSubmitting,
		setConfirmState,
		confirmSurgery,
	} = useConfirmBooking();

	const showConfirmButton = checkConfirmAppointment(appointment.date, isSurgery);

	const handleConfirm = async () => {
		if (isOdonto) {
			await confirmOdonto(bookingNumber);
			return;
		}

		if (isExam) {
			await confirmExam(appointment.bookingNumber);
			return;
		}

		if (isSurgery) {
			await confirmSurgery(Number(appointment.bookingNumber));
			return;
		}

		await confirmHealth(bookingNumber);
	};

	const description = () => {
		if (isExam) return confirmAppointmentModal.subTitleExam;
		if (isSurgery) return confirmAppointmentModal.subTitleSurgery;
		return confirmAppointmentModal.subTitle;
	};

	return {
		showConfirmButton,
		isPending,
		isError,
		isSubmitting,
		handleConfirm,
		description,
		setConfirmState,
	};
}
